import mapboxgl from 'mapbox-gl'

export const flyToBillboard = (map: mapboxgl.Map | undefined, lng: number, lat: number, zoom: number = 14) => {
  if (!map) return
  
  map.flyTo({
    center: [lng, lat],
    zoom
  })
}

export const fitToBounds = (map: mapboxgl.Map | undefined, bounds: mapboxgl.LngLatBoundsLike, padding: number = 50) => {
  if (!map) return
  
  map.fitBounds(bounds, { padding })
}

export const boundsFromZipFeature = (feature: GeoJSON.Feature): mapboxgl.LngLatBoundsLike | null => {
  if (!feature?.geometry) return null
  
  const coordinates = extractCoordinatesFromGeometry(feature.geometry)
  if (coordinates.length === 0) return null
  
  let minLng = coordinates[0][0]
  let maxLng = coordinates[0][0]
  let minLat = coordinates[0][1]
  let maxLat = coordinates[0][1]
  
  coordinates.forEach(([lng, lat]) => {
    minLng = Math.min(minLng, lng)
    maxLng = Math.max(maxLng, lng)
    minLat = Math.min(minLat, lat)
    maxLat = Math.max(maxLat, lat)
  })
  
  return [
    [minLng, minLat],
    [maxLng, maxLat]
  ]
}

const extractCoordinatesFromGeometry = (geometry: GeoJSON.Geometry): number[][] => {
  const coordinates: number[][] = []
  
  if (geometry.type === 'Point') {
    coordinates.push(geometry.coordinates as number[])
  } else if (geometry.type === 'Polygon') {
    geometry.coordinates[0].forEach(coord => coordinates.push(coord))
  } else if (geometry.type === 'MultiPolygon') {
    geometry.coordinates.forEach(polygon => {
      polygon[0].forEach(coord => coordinates.push(coord))
    })
  }
  
  return coordinates
}
